
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface CustomerInformationTabProps {
  customer: any;
}

export function CustomerInformationTab({ customer }: CustomerInformationTabProps) {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Informações Pessoais</CardTitle>
        </CardHeader>
        <CardContent>
          <dl className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <dt className="text-sm font-medium text-gray-500">Nome</dt>
              <dd>{customer.name}</dd>
            </div>
            <div>
              <dt className="text-sm font-medium text-gray-500">E-mail</dt>
              <dd>{customer.email}</dd>
            </div>
            <div>
              <dt className="text-sm font-medium text-gray-500">Telefone</dt>
              <dd>{customer.phone}</dd>
            </div>
            <div>
              <dt className="text-sm font-medium text-gray-500">Endereço</dt>
              <dd>{customer.address}</dd>
            </div>
          </dl>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Resumo</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="p-4 rounded-lg border bg-muted/20">
              <div className="text-sm font-medium text-gray-500">Total Gasto</div>
              <div className="text-2xl font-bold">{customer.totalSpent}</div>
              <div className="text-xs text-gray-500 mt-1">{customer.purchases} compras</div>
            </div>
            <div className="p-4 rounded-lg border bg-muted/20">
              <div className="text-sm font-medium text-gray-500">Saldo de Cashback</div>
              <div className="text-2xl font-bold">{customer.cashbackBalance}</div>
              <div className="text-xs text-gray-500 mt-1">Disponível para uso</div>
            </div>
            <div className="p-4 rounded-lg border bg-muted/20">
              <div className="text-sm font-medium text-gray-500">Indicações</div>
              <div className="text-2xl font-bold">{customer.referralCount}</div>
              <div className="text-xs text-gray-500 mt-1">Clientes indicados</div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
